export default "__VITE_ASSET__YxUXN4jGN9rNFtUJJlYGtw__"